import React, { useState, useMemo, useEffect } from 'react';
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { DialogPdf } from '../../pures';
import "./validate-freelance.css";

const ValidateFreelancePDFView = (props) => {
    const {
        urlDocument
    } = props

    const [urlPdf, setUrlPdf] = useState(urlDocument)
    const [blobAWS, setBlobAWS] = useState(urlDocument);

    useEffect(() => {
        setUrlPdf(urlDocument)
        setBlobAWS(urlDocument)
    }, [urlDocument])

    const pdf = useMemo(() => <PdfReader className="pdfReader" url={urlPdf} awsURL showDownloadPDF={false} />, [urlPdf])

    return (
        <div className='validateFreelanceView-documentPDF' >
            <div className='validateFreelanceView-documentPDF-container'>
                {pdf}
            </div>
            <div className="validateFreelanceView-documentPDF-pdf-btn">
                <DialogPdf blobUrl={blobAWS} />
            </div>
        </div>
    )
}

export { ValidateFreelancePDFView as default }